<template>
  <div>
    <div class="logo" :style="'background-color:' + this.$store.state.empresa.cor_secundaria">
      <div class="content">
        <img :src="this.$store.state.url_files + 'logos/'+this.$store.state.empresa.logo" alt="Logo" :style="'height: 130px; border-radius: 10px;border-style: solid;border-width: 5px;width: auto; border-color:' + this.$store.state.empresa.cor_splash_borda_logo">
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "StandbyScreenComponent"
    }
</script>

<style scoped>
  .logo {
    z-index: 10;
    width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    transition: all 0.3s ease 0s;
    background: rgb(111, 173, 228);
  }
  .logo .content {
    width: 100%;
    height: 160px;
    max-width: 1200px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    padding: 30px;
  }
  .logo .content > img {
    height: 90px;
    width: 100%;

  }

  .logo {
    z-index: 10;
    width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    transition: all 0.3s ease 0s;
    background: #EE6E73;
  }
</style>



// WEBPACK FOOTER //
// src/app/components/StandbyScreenComponent.vue